export default __webpack_public_path__ + "static/media/Letter R.810eb5fc.mov";